import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { FexidocLogo } from "@/components/FexidocLogo";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-5">
      <div className="max-w-md w-full text-center">
        <div className="mb-8"><FexidocLogo size={32}/></div>
        <div className="fx-panel p-10">
          <XCircle size={40} className="mx-auto text-slate-400" data-testid="payment-cancelled"/>
          <div className="font-display text-xl font-bold mt-4">Checkout cancelled</div>
          <div className="text-sm text-slate-400 mt-2">No charge was made. You can try again anytime.</div>
          <div className="mt-6 flex justify-center gap-2">
            <Link to="/app/billing" className="fx-btn-primary text-white px-5 py-2.5 rounded-lg font-medium">Back to billing</Link>
            <Link to="/app" className="border border-white/10 hover:border-white/20 text-slate-200 px-5 py-2.5 rounded-lg">Dashboard</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
